import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, catchError, map, tap } from 'rxjs';
import { Injectable } from '@angular/core';
import { CustomFormatErrorHandlerService, LoadingService } from '../services';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  constructor(
    private loadingService: LoadingService,
    private errorHandlerService: CustomFormatErrorHandlerService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let obs: Observable<HttpEvent<any>> = next.handle(request).pipe(
      tap({
        // On success, clear any overrides of the error handler,
        // Else it will intercept an unrelated error
        next: event => {
          if (event instanceof HttpResponse) {
            this.errorHandlerService.clearOverride();
          }
        },
      }),
    );
    if (this.loadingService.mustInterceptNextRequest) {
      this.loadingService.interceptNextRequest(false);
      this.loadingService.setLoading(request.url, true);
      obs = obs
        .pipe(
          catchError(err => {
            this.loadingService.setLoading(request.url, false);
            throw err;
          }),
        )
        .pipe(
          map<HttpEvent<any>, any>((evt: HttpEvent<any>) => {
            if (evt instanceof HttpResponse) {
              this.loadingService.setLoading(request.url, false);
            }
            return evt;
          }),
        );
    }
    return obs;
  }
}
